import React from 'react';
import MortalityMap from '../MortalityMap/MortalityMap.jsx';
import PortMap from '../PortMap/PortMap.jsx';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';
import Inset from '../../Inset/Inset.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
let portranking = [
	{
		"name": "Shanghai, China",
		//"volume": 33.62,
        "volume": 36.5,
        "rank": 1
	},
	{
		"name": "Singapore",
		//"volume": 32.6,
        "volume": 30.9,
        "rank": 2
	},
	{
		"name": "Shenzhen, China",
		//"volume": 23.28,
        "volume": 24.2,
        "rank": 3
	},
    {
		"name": "Ningbo-Zhoushan, China",
		/*"volume": 17.33,
        "rank": 6*/
        "volume": 20.6,
        "rank": 4
	},
	{
		"name": "Hong Kong, S.A.R., China",
		/*"volume": 22.35,
        "rank": 4*/
        "volume": 20.1,
        "rank": 5
	},
	{
		"name": "Busan, South Korea",
		/*"volume": 17.69,
        "rank": 5*/
        "volume": 17.8,
        "rank": 6
	},
	{
		"name": "Qingdao, China",
		//"volume": 15.52,
        "volume": 17.3,
        "rank": 7
	},
    {
		"name": "Jebel Ali, Dubai, United Arab Emirates",
		/*"volume": 13.64,
        "rank": 9*/
        "volume": 15.6,
        "rank": 8
	},
	{
		"name": "Guangzhou Harbor, China",
		/*"volume": 15.31,
        "rank": 8*/
        "volume": 15.0,
        "rank": 9
	},
	{
		"name": "Tianjin, China",
		//"volume": 13.01,
        "volume": 14.1,
        "rank": 10
	}
];


export default class PortStory extends React.Component {
    render() {
        let maxportvolume = portranking.map(v => v.volume).reduce((prev,cur) => cur>prev?cur:prev,0);
        return <div className="inset-text portstory">
            <Inset hed="Death on the Coasts" dek="The most recent study of cardiopulmonary deaths from shipping emissions is around a decade old. Dr. Corbett, the main author of that study, says the number of deaths has likely risen with increases in emissions and coastal populations in Asia.">
                <div className="deathmap">
                    <SubInset hed="Yearly deaths due to ship PM2.5 emissions (according to seminal 2007 study) vs. current emission control areas" notes={["Note: A reduction in deaths is expected in coastal areas adjacent to ECAs, as sulfur limits have become stricter since the release of the study."]}
                    source="Sources: Corbett, Winebrake, et al., Mortality from ship emissions, 2007 (mortality); International Maritime Organization (ECAs)">
                        <SizeGiver>
                            <MortalityMap />
                        </SizeGiver>
                    </SubInset>
                </div>
                <div className="container portranks">
                    <SubInset hed="The World's Busiest Ports in 2015" source="Source: the ports">
                        <div className="row">
                            <div className="col l6 m6 s12">
                                <SizeGiver>
                                    <PortMap />
                                </SizeGiver>
                            </div>
                            <div className="col l6 m6 s12">
                                
                                    <table style={{width:"100%"}} className="ranktable">
                                        <thead>
                                            <tr>
                                                <th data-field="rank" style={{textAlign:"center"}} >Rank</th>
                                                <th data-field="port">Port</th>
                                                <th data-field="price">
                                                    <span style={{whiteSpace:"nowrap"}}>Container volume</span>
                                                    <br/> 
                                                    <span style={{whiteSpace:"nowrap"}}>(millions of TEU)</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {portranking.map((port,i) => <tr>
                                                <td style={{textAlign:"center"}} ><span className="rank">{port.rank}</span></td>
                                                <td>{port.name}</td>
                                                <td>
                                                    <div className="portbar" style={{
                                                        whiteSpace:"nowrap",
                                                        width:port.volume/maxportvolume*100+"%"
                                                    }}>
                                                        <span className="bartext">{port.volume.toFixed(1)}</span>
                                                    </div>
                                                </td> 
                                            </tr>)}
                                        </tbody>
                                    </table>
                            </div>
                        </div>
                    </SubInset>
                </div>
            </Inset>
        </div>
    }
    
}


// WEBPACK FOOTER //
// ./src/js/components/special/PortStory/PortStory.jsx